/**
 * Backoffice permissions
 */
export const ROLE_SUPPORT = 5;
export const ROLE_MASTER = 100;
export const ROLE_MARKETING = 4;

/**
 * Admin permissions
 */
export const ROLE_ADMIN = 1;
export const ROLE_EXPERT = 2;

export const ROLES = [
  {
    text: 'Master',
    reference: ROLE_MASTER,
  },
  {
    text: 'Suporte',
    reference: ROLE_SUPPORT,
  },
  {
    text: 'Marketing',
    reference: ROLE_MARKETING,
  },
];

export const ALL_ROLES = [
  {
    text: 'Administrador',
    reference: ROLE_ADMIN,
  },
  {
    text: 'Operador',
    reference: ROLE_EXPERT,
  },
  ...ROLES
];
